<template>
    <div id="logincontent" :style="loginimg" >
      <el-form ref="loginForm" :model="form" :rules="rules" label-width="0px" class="login-box">
        <h3 class="login-title">注册账号</h3>
        <el-form-item label="" prop="username">
          <el-input type="text" placeholder="请输入账号" v-model="form.username" prefix-icon="el-icon-user" />
           
        </el-form-item>
        <el-form-item label="" prop="password1">
          <el-input type="password" placeholder="请输入密码" v-model="form.password1" prefix-icon="el-icon-lock"/> 
        </el-form-item>
        <el-form-item label="" prop="password2">
          <el-input type="password" placeholder="确认密码" v-model="form.password2" prefix-icon="el-icon-lock"/> 
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('loginForm')" class="loginsubmit">注册</el-button>
        </el-form-item>
        <el-form-item>
            <router-link to="/" class="link">返回登录</router-link>
        </el-form-item>
      </el-form>
    </div>
  </template>
  
  <script>
    export default {
      name: "Login",
      data() {
        return {
          form: {
            username: '',
            password1: '',
            password2: '',

          },

          loginimg:{
            backgroundImage: "url(./static/images/loginbackground.jpg)",
            backgroundSize:'100% 100%',
            width:'100%',
            height:'100%',
            backgroundRepeat:'no-repeat',
            position:'absolute',
            left:'0',
            top:'0'
          },
  
          // 表单验证，需要在 el-form-item 元素中增加 prop 属性
          rules: {
            username: [
              {required: true, message: '账号不可为空', trigger: 'blur'}
            ],
            password1: [
              {required: true, message: '密码不可为空', trigger: 'blur'}
            ],
            password2: [
              {required: true, message: '密码不可为空', trigger: 'blur'}
            ]
          },
        }
      },
      methods: {
        onSubmit(formName) {
          // 为表单绑定验证功能
          this.$refs[formName].validate((valid) => {
            if (valid) {

              if(this.form.password1==this.form.password2){
                var Register=this.GLOBAL.Register;
                this.$http.post(Register,{username:this.form.username,password:this.form.password1},{'headers': {'Content-Type': 'application/json'}},{emulateJSON:true}).then(function(res){
                      // console.log(res); 
                      if(res.body.code==200){
                        this.$message({
                          message: res.body.msg,
                          type: 'success'
                        });   

                      }
                                         
                },function(err){})

              }
              else{
                this.$message.error('两次输入密码不一致');
              }
              
            } else {
              return false;
            }
          });
        }
      }
    }
  </script>
  
  <style  scoped>
    .login-box {
      border: 1px solid #DCDFE6;
      width: 300px;
      margin: 260px auto;
      padding: 25px 35px 0px 35px;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      box-shadow: 0 0 25px #909399;
      background: #ffffff;
    }
  
    .login-title {
      text-align: center;
      margin: 0 auto 40px auto;
      color: #303133;
    }
    .loginsubmit{
        width: 100%;
    }
    .link{
        color: #409eff;
        text-decoration: none;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/LOGINREGISTER/register.vue